import { render, staticRenderFns } from "./shorting-filter.vue?vue&type=template&id=5a8b1312"
import script from "./shorting-filter.vue?vue&type=script&lang=js"
export * from "./shorting-filter.vue?vue&type=script&lang=js"
import style0 from "./shorting-filter.vue?vue&type=style&index=0&id=5a8b1312&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports